/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { CustomersState } from '@app/customers/store/customers.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectCustomersState = createFeatureSelector<CustomersState>('customers');

export const getCustomers = createSelector(selectCustomersState, state => state.customers);
export const getCustomersPartial = createSelector(selectCustomersState, state => state.customersPartial);
export const isActionPending = createSelector(selectCustomersState, state => state.actionPending);
